<!--
  - Copyright (c) 2020 brightlamp
  -->

<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent :max-width="params.maxWidth ? params.maxWidth : 310">
            <v-card>
                <v-card-title class="headline" style="color:#FFFD00;background-color:#363636;">{{ params.title }}</v-card-title>
                <v-card-text class="mt-2" style="color:#000000;">{{ params.text }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :color="params.positiveColor ? params.positiveColor : 'blue darken-1'" text @click="negativeResponse">{{ params.negativeResponse }}</v-btn>
                    <v-btn :color="params.negativeColor ? params.negativeColor : 'blue darken-1'" text @click="positiveResponse">{{ params.positiveResponse }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    export default
    {
        name: 'confirmation-dialog',
        data: function ()
        {
            return {
                dialog: Boolean(true),
            }
        },
        props:
        {
            params: {}
        },
        methods:
        {
            positiveResponse()
            {
                this.$emit('confirmation-dialog-response', {response: true, context: this.params.context})
            },
            negativeResponse()
            {
                this.$emit('confirmation-dialog-response', {response: false, context: this.params.context})
            }
        }
    };
</script>

<style scoped>
</style>